var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6659_59679)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21,
    stroke: "#FCF7F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6659_59679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4961 32.5334L28.7861 30.7661C28.8935 30.6934 29.0009 30.6206 29.0737 30.5513L36.1393 21.9367C36.3542 21.6109 36.3195 21.1812 36.0319 20.9283L32.6775 18.1526C32.4003 17.9482 31.9741 17.917 31.7038 18.26L24.6035 26.8712C24.5307 26.9786 24.4961 27.086 24.458 27.1969L23.557 31.7745C23.5119 32.5577 24.1392 32.6928 24.4961 32.5334ZM32.3172 19.6981L34.5869 21.5728L28.4291 29.0959L26.1802 27.235L32.3172 19.6981ZM25.6223 28.635L27.1609 29.9102L25.1787 30.728L25.6223 28.635Z",
    fill: "#606062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2561 33.5424H25.145C25.145 33.5424 22.6327 33.6602 22.5391 33.0157C22.5391 32.981 22.4767 32.8216 22.8025 32.4266C23.0554 32.1009 23.0173 31.6712 22.7297 31.4182C22.404 31.1653 21.9743 31.2034 21.7213 31.491C21.0352 32.3192 20.855 33.04 21.1807 33.6914C22.0644 35.3374 25.0376 34.9493 25.1796 34.984H37.2561C37.6511 34.984 37.9768 34.6582 37.9768 34.2632C37.9803 33.8647 37.6546 33.5424 37.2561 33.5424Z",
    fill: "#606062"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6659_59679",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 0 0.313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6659_59679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6659_59679",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6659_59679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(21 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignEdit);
export default __webpack_public_path__ + "static/media/signEdit.3e0b3919027673421b766696118fee4b.svg";
export { ForwardRef as ReactComponent };